

import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SignedIn, SignedOut, useSession } from "@clerk/clerk-react";
import { useEffect } from "react";
import Dashboard from "./pages/Dashboard";
import Settings from "./pages/Settings";
import Marketing from "./pages/Marketing";
import AuthLayout from "./components/AuthLayout";
import LoginPage from "./pages/LoginPage";
import OfferDesigner from "./pages/OfferDesigner";
import RevenuePlays from "./pages/RevenuePlays";
import Insights from "./pages/Insights";
import OrderSpy from "./pages/OrderSpy";
import BoxTopper from "./pages/BoxTopper";
import NotFound from "./pages/NotFound";
import OfferPage from "./pages/public/OfferPage";

import QueryProviderWithNavigation from "./QueryProviderWithNavigation";

// Everything today's Clerk gate covers, unchanged. Split out of App so the
// public consumer routes below (no Clerk, no AuthLayout, no PIN) never mount
// SignedIn/SignedOut at all.
const GatedApp = () => {
  const { session } = useSession();
  void session;

  return (
    <>
      <SignedOut>
        <LoginPage />
      </SignedOut>
      <SignedIn>
        <AuthLayout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/settings" element={<Settings />} />
            {/* The old Customers page now lives as the Contacts tab of /marketing. */}
            <Route path="/subscribers" element={<Navigate to="/marketing?tab=contacts" replace />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/revenue-plays" element={<RevenuePlays />} />
            <Route path="/marketing" element={<Marketing />} />
            <Route path="/offer-designer" element={<OfferDesigner />} />
            <Route path="/orderspy" element={<OrderSpy />} />
            <Route path="/box-topper" element={<BoxTopper />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthLayout>
      </SignedIn>
    </>
  );
};

const App = () => {
  return (
    <QueryProviderWithNavigation>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            {/* Public consumer page: no Clerk, no AuthLayout, no PIN (OP-1). */}
            <Route path="/o/:code" element={<OfferPage />} />
            <Route path="*" element={<GatedApp />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryProviderWithNavigation>
  );
};

export default App;
